class NavProductItem extends HTMLElement {
    constructor() {
        super();
        this.colorList = this.querySelector('.card_product-card__swatch--list');
        this.colorSwatch = this.colorList ? this.colorList.querySelectorAll('.color-swatch-item') : [];
        this.imageBox = this.querySelector('.nav-image-box');
        this.colorImagesList = this.querySelector('.color_swatch_image_list');
        this.colorImages = this.colorImagesList ? this.colorImagesList.querySelectorAll('.color_swatch_image__item') : [];

        if (this.colorList && this.colorImagesList) {
            this.colorSwatch.forEach((swatch, index) => {
                swatch.addEventListener('mouseenter', () => this.switchImage(index));
            });
        }
    }

    switchImage(index) {
        // 判断.nav-image-box有没有“active”类名
        if (!this.imageBox.classList.contains('active')) {
            this.imageBox.classList.add('active');
        }

        // 移除所有colorImage的“active”类
        this.colorImages.forEach(image => {
            image.classList.remove('active');
        });

        // 将第N个colorImage增加类名“active”
        if (this.colorImages[index]) {
            this.colorImages[index].classList.add('active');
        }
    }
}

customElements.define('nav-product-item', NavProductItem);
